import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PACKAGES } from "../data/staticData";

export default function PricingDRGrid() {
  const drs = PACKAGES["guest-posting"];
  return (
    <div className="card-soft overflow-hidden" data-testid="pricing-dr-grid">
      <div className="grid grid-cols-12 px-6 py-4 border-b border-line bg-surfaceAlt/60 text-xs uppercase tracking-[0.18em] text-inkSoft font-semibold">
        <div className="col-span-3">DR Range</div>
        <div className="col-span-3">Highlights</div>
        <div className="col-span-2">Turnaround</div>
        <div className="col-span-2 text-right">Price</div>
        <div className="col-span-2 text-right">Order</div>
      </div>
      {drs.map((d, i) => (
        <div
          key={d.id}
          className={`grid grid-cols-12 px-6 py-5 items-center text-sm ${i % 2 ? "bg-bg" : "bg-white"} ${i !== drs.length - 1 ? "border-b border-line" : ""}`}
          data-testid={`dr-row-${d.id}`}
        >
          <div className="col-span-3 font-mono font-semibold">{d.dr}</div>
          <div className="col-span-3 text-ink/80">{d.features[0]}</div>
          <div className="col-span-2 text-inkSoft">{d.turnaround}</div>
          <div className="col-span-2 text-right font-mono font-semibold">${d.price}</div>
          <div className="col-span-2 text-right">
            <Link
              to={`/signup?service=guest-posting&package=${d.id}`}
              className="inline-flex items-center gap-1 text-terra font-medium hover:underline"
              data-testid={`dr-order-${d.id}`}
            >
              Order <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}
